import React from "react";
import styles from "./index.module.css";
import { joinClass } from "../../helpers/utils";

const ModalV2 = ({ children, onCancel, type = "center" }) => {
  const modalClass = {
    center: styles["modal_v2--data"],
    bottom: styles["modal_v2--bottom"],
    full: styles["modal_v2--full"],
  };

  return (
    <>
      <div className={styles["modal__v2__overlay"]} onClick={onCancel}></div>
      <div className={joinClass(modalClass[type])}>{children}</div>
    </>
  );
};

export default ModalV2;
